import React from 'react';
import moment from 'moment';

import {
    Table,
    Button,
    Tag,
    Card,
    Popconfirm,
    Input,
    Icon,
} from 'antd'

import {
    _getFinanceNotifications,
    _putFinanceNotificationStatus
} from '../../../services'

import {
    ADMIN_URL
} from '../../../index'

const STATUS = {
    REJECTED: 'REJECTED',
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    OPEN: 'OPEN'
}

const NOTIFICATION_TYPES = {
    REFUND: 'REFUND',
    VOID: 'VOID',
    AMEND_INVOICE: 'AMEND_INVOICE',
    TOP_UP_INVOICE: 'TOP_UP_INVOICE'
}

const notificationTypeDict = {
    'Refund': [
        'Item out of stock',
        'Item discontinued',
        'Buyer cancel order – long lead time',
        'Buyer cancel order – change of price',
        'Buyer cancel order – change of mind',
        'Others (Please state in remarks)'
    ],
    'Refund & Amend Invoice': [
        'Item out of stock',
        'Item discontinued',
        'Buyer cancel order – long lead time',
        'Buyer cancel order – change of price',
        'Buyer cancel order – change of mind',
        'Others (Please state in remarks)'
    ],
    'Amend Invoice': [
        'Change of quantity',
        'Replace with alternate item / with lower price',
        'Others (Please state in remarks)'
    ],
    'Issue Credit Note': [
        'Item out of stock',
        'Item discontinued',
        'Buyer cancel order – long lead time',
        'Buyer cancel order – change of price',
        'Buyer cancel order – change of mind',
        'Others (Please state in remarks)'
    ],
    'Top Up Invoice': [
        'Additional item',
        'Alternate item / model',
        'Delivery charges',
        'Others (Please state in remarks)'
    ],
    'Void': [
        'Order pushed wrongly',
        'PO cancelled',
        'Fake order',
        'Others (Please state in remarks)'
    ]
}

class NotificationManager extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            notifications : [],

            limit: 20,
            page: 1,
            notificationCount: 1,

            statusFilter: [],
            typeFilter: [],
            createdByList: [],
            createdByFilter: [],

            refNumber_search: '',
            offlineReferenceNumber_search: '',
        }
    }

    render() {
        return(
            <Card>
                {this.renderNotificationTable()}
            </Card>
        )
    }

    componentDidMount() {
        this.getNotifications()
    }

    getNotifications = () => {

        const { 
            page, limit, 
            statusFilter, typeFilter, createdByFilter,
            refNumber_search, offlineReferenceNumber_search
        } = this.state

        _getFinanceNotifications({page,limit, statusFilter, typeFilter, createdByFilter, refNumber_search, offlineReferenceNumber_search})
        .then(_notifications => {
            this.setState({
                notificationCount: _notifications.data.count,
                notifications: _notifications.data.results,
                createdByList: _notifications.data.createdBy,
            })
        })
    }

    renderNotificationTable = () => {
        const {notifications, limit, page, notificationCount, createdByList} = this.state

        const columns = [{
            title: 'refNumber',
            dataIndex: 'refNumber',
            ...this.getColumnSearchProps('refNumber'),
        },{
            title: 'Invoice Number',
            dataIndex: 'offlineReferenceNumber',
            ...this.getColumnSearchProps('offlineReferenceNumber'),
            render: (offlineReferenceNumber, record) => <a href={`${ADMIN_URL}/orders?target=${record.cartId}`} target='_blank'>{offlineReferenceNumber}</a>
        },{
            title: 'Type',
            dataIndex: 'type',
            filters: Object.keys(notificationTypeDict).map(type => ({text: type, value: type})),
            filteredValue: this.state.typeFilter
        },{
            title: 'Reason',
            dataIndex: 'reason',
            // filters: Object.keys(notificationTypeDict).map(type => ({text: type, value: type})),
            // filteredValue: this.state.typeFilter
        },{
            title: 'Remarks',
            dataIndex: 'remarks',
            render: (remarks) => <div style={{maxWidth: 250, wordBreak: 'break-word'}}>{remarks}</div>
        },{
            title: 'Requested By',
            dataIndex: 'createdBy',
            // render: (createdBy) => createdBy.name,
            filters: createdByList.map(type => ({text: type, value: type})),
            filteredValue: this.state.createdByFilter,
            render: (createdBy, record) => {
                return (
                    <div>
                        <div>{createdBy.name}</div>
                        <div>{moment(record.dateCreated).format('LLL')}</div>
                    </div>
                )
            }
        },
        // {
        //     title: 'Requested On',
        //     dataIndex: 'dateCreated',
        //     render: (dateCreated) => moment(dateCreated).format('LLL')
        // },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (status, record) => this.renderTag(status, record),
            filters: Object.keys(STATUS).map(status => ({text: status, value: status})),
            filteredValue: this.state.statusFilter
        },{
            title: 'Actions',
            render: (action, record) => {
                if (record.status=='PENDING') {
                    return this.renderActionButtons(record._id, record.status)
                }
                if (record.completedBy) {
                    return record.completedBy.name
                }
                return this.renderActionButtons(record._id)
            }
        }]
        return (
            <Table
                onChange={this.handleTableChange}
                dataSource={notifications}
                columns={columns}
                pagination={{
                    pageSize: limit,
                    current: page,
                    total: notificationCount,
                    onChange: (nextPage) => {
                        this.setState({ page: nextPage })
                    }
                }}
            />
        )
    }

    renderTag = (status, record) => {

        let color;

        switch(status) {
            case 'OPEN':
                color = 'blue'
                break;
            case 'PENDING':
                color = 'orange'
                break;
            case 'COMPLETED':
                color = 'green'
                break;
            case 'REJECTED':
                color = 'red';
                break;
            default:
                color = 'blue'
        }

        if (record.status=='PENDING') {
            return <div>
                 <Tag color={color}>{status}</Tag>
                <div>{record.completedBy.name}</div>
            </div>
        }
        return <Tag color={color}>{status}</Tag>
 
    }

    renderActionButtons = (notificationId, status) => {
        return (
            <div>
                <Popconfirm
                    title="Confirm Done?"
                    onConfirm={() => this.handleDoneClick({notificationId, status: 'COMPLETED'})}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button size="small" style={{marginRight: 8}} type='primary'>Complete</Button>
                </Popconfirm>
                <Popconfirm
                    title="Confirm Rejection?"
                    onConfirm={() => this.handleDoneClick({notificationId, status: 'REJECTED'})}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button size="small" type='danger'>Reject</Button>
                </Popconfirm>
                {status!='PENDING' && <Popconfirm
                    title="Confirm Pending?"
                    onConfirm={() => this.handleDoneClick({notificationId, status: 'PENDING'})}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button size="small" type='warning'>Pending</Button>
                </Popconfirm>}
            </div>
        )
    }

    handleTableChange = (pagination, filters, sorter, extra) => {

        this.setState({
            statusFilter: filters.status,
            typeFilter: filters.type,
            createdByFilter: filters.createdBy,
            current: pagination.current
        }, this.getNotifications)
    }

    handleDoneClick = ({notificationId, status}) => {
        _putFinanceNotificationStatus({notificationId, status})
        .then(result => {
            this.getNotifications()
        })
    }

    // FOR COLUMN SEARCH

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={this.state[`${dataIndex}_search`]}
                    // onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onChange={(e => this.setState({[`${dataIndex}_search`]: e.target.value}))}
                    onPressEnter={() => this.handleSearch(confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(confirm, dataIndex)}
                        icon='search'
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
              </Button>
                    <Button onClick={() => this.handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
                        Reset
              </Button>
            </div>
        ),
        filterIcon: filtered => <Icon type='search' />,
        // onFilter: (value, record) =>
        //     record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        // onFilterDropdownVisibleChange: visible => {
        //     if (visible) {
        //         setTimeout(() => this.searchInput.select());
        //     }
        // },
        render: text => text
    });

    handleSearch = (confirm, dataIndex) => {
        confirm();
        // Page is set to 1 because if on handleSearch page==2 but results only has 1 page, cant see any results
        this.setState({
            page: 1
        }, this.getNotifications)
        
    };

    handleReset = (clearFilters, dataIndex) => {
        clearFilters();
        this.setState({ 
            [`${dataIndex}_search`]: '' 
        },this.getNotifications);
        
    };

}

export default NotificationManager


// WEBPACK FOOTER //
// ./src/components/finance/notification/manager.js